import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { STUFFED_IMAGE, STUFFED_POINTS } from './salesData';

/**
 * DESEO, segunda ola y momento visual más potente de la carta: una única
 * fotografía enorme de la cookie partida al medio. El texto acompaña, no compite.
 */
export function StuffedSection() {
  return <section className="overflow-hidden bg-ivory pb-14 sm:pb-20" aria-labelledby="stuffed-title" data-id="element-329" data-mp="fxl5yrq9g2p3">
      <motion.figure initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.35,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative" data-id="element-330" data-mp="3odeb6af55rqu">
        <img src={STUFFED_IMAGE} alt="Cookie gruesa partida al medio con dulce de leche y chocolate fundido estirándose entre las dos mitades." loading="lazy" decoding="async" className="h-[62vh] max-h-[620px] w-full object-cover sm:h-auto sm:max-h-none" style={{
        paddingBottom: "35px"
      }} data-id="element-331" data-mp="3scdnwh746ssu" />
      </motion.figure>

      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-332" data-mp="sqjn2m558tcw">
        <div className="-mt-12 rounded-5xl bg-white px-6 py-8 shadow-bakery sm:-mt-20 sm:px-12 sm:py-12" data-id="element-333" data-mp="wt6i0vx42ueb">
          <div className="grid gap-8 lg:grid-cols-12 lg:items-start lg:gap-14" data-id="element-334" data-mp="11sj61jzpy7ih">
            <div className="lg:col-span-7" data-id="element-335" data-mp="11qgj58tv4uhz">
              <SectionTag data-id="element-336" data-mp="16qb8h7xzpc0x">El relleno</SectionTag>
              <h2 id="stuffed-title" className="mt-4 font-display text-[1.95rem] leading-[1.08] text-charcoal sm:text-[2.9rem]" data-id="element-337" data-mp="16p05398gi6ac">
                El corte es lo que la gente fotografía
              </h2>
              <p className="mt-4 max-w-xl font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-338" data-mp="j0qoqmu0iaql">
                De las cien variedades, veinticinco son rellenas. Dulce de leche, ganache, cremas y
                centros fundentes que quedan exactamente donde tienen que quedar cuando se parte la
                cookie al medio.
              </p>
            </div>

            <ul className="lg:col-span-5" data-id="element-339" data-mp="3jgnmddk7srmi">
              {STUFFED_POINTS.map((point, index) => <motion.li key={point} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.5
            }} transition={{
              duration: 0.26,
              ease: [0.23, 1, 0.32, 1],
              delay: Math.min(index, 4) * 0.035
            }} className="flex items-baseline gap-3 border-b border-warm py-3 first:border-t" data-id="element-340" data-mp="3ffk3ei6vefh2" data-mpi={index}>
                  <span className="font-display text-[0.8rem] tabular-nums text-caramel" aria-hidden data-id="element-341" data-mp="3agh8hqkltpmt">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="font-display text-[1rem] text-charcoal sm:text-[1.1rem]" data-id="element-342" data-mp="ps31boggvvqi">
                    {point}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}